import { render, staticRenderFns } from "./PrintCurrentBalanceDialog.vue?vue&type=template&id=23692098"
import script from "./PrintCurrentBalanceDialog.vue?vue&type=script&lang=js"
export * from "./PrintCurrentBalanceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports